<template>
  <div
    class="tuolele-main-box account-financial"
    style="padding-top: 1px !important;"
  >
    <div class="data-type-tab">
      <el-tabs v-model="activeName">
        <el-tab-pane label="概览" name="1" />
        <el-tab-pane label="财务管理" name="2" />
      </el-tabs>
    </div>
    <div class="financial-content">
      <div v-show="activeName == '1'" class="financial-view">
        <div class="color-black financial-box">
          <el-row class="title">乐币余额信息</el-row>
          <el-row :gutter="20" class="financial-item">
            <el-col :span="8" align="center" class="total">
              <el-row>总余额（乐币）</el-row>
              <el-row>{{
                Number(companyAccountInfo.company_info.l_coin) +
                  Number(companyAccountInfo.company_info.give_l_coin)
              }}</el-row>
              <!-- <el-row><i class="el-icon-warning prompt"> &nbsp;当前账户已欠费，请及时充值</i></el-row>               -->
            </el-col>
            <el-col :span="8">
              <el-row><span>正式余额（乐币）</span>
                {{ companyAccountInfo.company_info.l_coin }}</el-row>
              <el-row><span>赠送余额（乐币）</span>
                {{ companyAccountInfo.company_info.give_l_coin }}</el-row>
            </el-col>
            <el-col :span="8">
              <el-row class="charge">
                <div @click="recharge">
                  <i class="el-icon-warning" /><br>
                  <b>乐币充值</b>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="color-black financial-box">
          <el-row class="title">店铺概况</el-row>
          <el-table
            :data="companyAccountInfo.shop_list"
            border
            stripe
            max-height="450"
          >
            <el-table-column prop="name" label="店铺" />
            <el-table-column
              prop="validity_date"
              label="有效期"
            />
            <!-- <el-table-column label="到期自动续费">
               <template slot-scope="scope">
                <el-switch v-model="scope.row.status"> </el-switch>
              </template>
            </el-table-column>  -->
            <el-table-column label="年费(乐币/年)">
              <template slot-scope="scope">
                <span>{{ scope.row.annual_fee }}</span>
                <el-button
                  class="charge-btn"
                  @click="renewal(scope.row)"
                >续费</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="corrects_number"
              label="可用批改张数"
            />
          </el-table>
        </div>
      </div>
      <div v-show="activeName == '2'" class="financial-manage">
        <el-row type="flex" justify="space-between">
          <el-col>
            <span class="color-black">数据日期：</span>
            <el-date-picker
              v-model="filterObj.begin_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            />
            <span>&nbsp;至&nbsp;</span>
            <el-date-picker
              v-model="filterObj.end_time"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            />
            &nbsp;&nbsp;
            <el-button type="primary" @click="getCapitalFlow">查询</el-button>
          </el-col>
          <el-button type="success" @click="exportExcel">导出Excel表</el-button>
        </el-row>
        <div class="data-financial-tab">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="支出明细" name="1" />
            <el-tab-pane label="账单记录" name="2" />
          </el-tabs>
        </div>
        <div class="data-financial-content">
          <el-table
            v-show="activeTab == '1'"
            :data="capitalFlowList"
            border
            stripe
            max-height="450"
          >
            <el-table-column prop="create_time" label="日期" />
            <el-table-column prop="summary" label="支出类型" />
            <el-table-column prop="value" label="支出乐币" />
          </el-table>
          <el-table
            v-show="activeTab == '2'"
            :data="billList"
            border
            stripe
            max-height="450"
          >
            <el-table-column
              prop="create_day"
              label="账单生成日期"
            />
            <el-table-column prop="year_month" label="账单月份">
              <template slot-scope="scope">
                <span>{{ scope.row.year_month.substr(0, 4) }}年{{
                  scope.row.year_month.substr(4)
                }}月</span>
              </template>
            </el-table-column>
            <el-table-column prop="total_amount" label="账单金额(乐币)">
              <template slot-scope="scope">
                <span>{{
                  Number(scope.row.total_amount) +
                    Number(scope.row.adjustment_amount)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="expendDetail(scope.row)"
                >查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog title="账单详情" :visible.sync="dialogVisible" width="60%">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="detail-title"
      >
        <!-- <el-col>账单日期 (2020-01-10 -- 2020-03-28)</el-col>  -->
        <el-col>
          <el-row type="flex" justify="end" align="middle">
            <span
              style="margin-right:10px;"
            >总计金额：{{
              Number(billInfo.total_amount) +
                Number(billInfo.adjustment_amount)
            }}乐币</span>
            <el-button type="success" @click="downLoad">下载账单</el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-table :data="billInfo.extra" border stripe max-height="450">
        <el-table-column prop="shop_name" label="店铺" />
        <el-table-column prop="count" label="数量" />
        <el-table-column
          prop="student_service_fee"
          label="学员服务费(乐币)"
        />
        <el-table-column
          prop="accounts_payable"
          label="应付学员服务费(乐币)"
        />
        <el-table-column
          prop="value_added_services"
          label="增值服务费(乐币)"
        />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'AccountFinancial',
  data() {
    return {
      activeName: '1',
      activeTab: '1',
      date: '',
      dialogVisible: false,
      tableData: [
        { name: '222222', flag: true },
        { name: '111111', flag: false },
        { name: '33333', flag: true }
      ],
      filterObj: {
        begin_time: '',
        end_time: ''
      },
      companyAccountInfo: {
        company_info: {
          l_coin: 0,
          given_l_coin: 0
        },
        shop_list: []
      },
      capitalFlowList: [],
      billList: [],
      billInfo: {}
    }
  },
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getAccountSummary()
    this.getCapitalFlow()
  },
  methods: {
    getAccountSummary() {
      this.$http.getAccountSummary().then(res => {
        if (res.code == 200) {
          this.companyAccountInfo = res.data
          this.companyAccountInfo.shop_list.forEach(function(e) {
            e.status = e.status == 1
          })
        }
      })
    },
    getCapitalFlow() {
      this.$http.getCapitalFlow(this.filterObj).then(res => {
        if (res.code == 200) {
          this.capitalFlowList = res.data.list
        }
      })
      this.$http.getBillList(this.filterObj).then(res => {
        if (res.code == 200) {
          this.billList = res.data.list
        }
      })
    },
    recharge() {
      this.$message({
        message: '请联系官方客服完成充值！',
        type: 'info'
      })
    },
    renewal(row) {
      this.$confirm(
        '确定要消耗' + row.annual_fee + '乐币为店铺' + row.name + '续费1年？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$http.setAnnualFee({ shop_id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '充值成功！',
              type: 'success'
            })
            this.getAccountSummary()
            this.getCapitalFlow()
          }
        })
      })
    },
    expendDetail(row) {
      this.dialogVisible = true
      this.$http.getBillInfo({ bill_id: row.bill_id }).then(res => {
        if (res.code == 200) {
          this.billInfo = res.data.info
        }
      })
    },
    exportExcel() {
      if (this.activeTab == '1') {
        const tHeader = ['日期', '支出类型', '支出乐币']
        const filterVal = ['create_time', 'summary', 'value']
        Tool.exportExcel(tHeader, filterVal, this.capitalFlowList, '支出明细')
      } else if (this.activeTab == '2') {
        const tHeader = ['账单生成日期', '账单月份', '账单金额（乐币）']
        const filterVal = ['create_day', 'year_month', 'total_amount']
        let list = JSON.stringify(this.billList)
        list = JSON.parse(list)
        list.forEach(e => {
          e.year_month =
            e.year_month.substr(0, 4) + '年' + e.year_month.substr(4) + '月'
          e.total_amount = Number(e.total_amount) + Number(e.adjustment_amount)
        })
        Tool.exportExcel(tHeader, filterVal, list, '账单记录')
      }
    },
    downLoad() {
      const tHeader = [
        '店铺',
        '数量',
        '学员服务费(乐币)',
        '应付学员服务费(乐币)',
        '增值服务费(乐币)'
      ]
      const filterVal = [
        'shop_name',
        'count',
        'student_service_fee',
        'accounts_payable',
        'value_added_services'
      ]
      Tool.exportExcel(tHeader, filterVal, this.billInfo.extra, '账单详情')
    }
  }
}
</script>
<style lang="scss">
.tuolele-main-box {
  .financial-box {
    background: #f9f8f8;
    .title {
      color: #fff;
      font-weight: bold;
      padding: 10px 0 10px 20px;
      background: #4c84ff;
    }
    .financial-item {
      padding: 30px 0;
      line-height: 40px;
    }
    span {
      margin-right: 30px;
    }
    .prompt {
      color: #de0b0b;
    }
    .charge {
      width: 110px;
      height: 110px;
      border: 1px solid #ccc;
      text-align: center;
      border-radius: 10px;
      cursor: pointer;
      i {
        font-size: 40px;
        margin: 18px 0 0;
      }
    }
    .el-table tr th {
      background: #fff !important;
      color: #333;
    }
    .charge-btn span {
      margin-right: 0 !important;
    }
  }
  .el-tabs__item:last-child {
    border-radius: 0 !important;
  }
  .el-tabs__nav-wrap::after {
    height: 1px !important;
  }
  .data-financial-tab {
    margin-top: 20px;
    .el-tabs__item {
      height: 45px !important;
      line-height: 45px !important;
      padding: 0 30px !important;
    }
  }
  .el-dialog__body {
    padding-top: 0;
    .detail-title {
      padding: 10px 0;
    }
  }
  // .el-table__header,.el-table__body{
  //   width: 100% !important
  // }
}
</style>
